import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  makeStyles,
  Typography,
  LinearProgress,
  Box,
} from "@material-ui/core";
import { LightenDarkenColor } from "lighten-darken-color";

const useStyles = makeStyles((theme) => ({
  contentHead: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
  },
  titles: {
    marginBottom: theme.spacing(0.75),
  },
  icon: {
    flexShrink: "0",
    padding: theme.spacing(1.5),
    fontSize: theme.spacing(7),
    marginTop: theme.spacing(0.25),
    marginRight: theme.spacing(1.5),
    borderRadius: "50%",
  },
  progress: {
    marginBottom: theme.spacing(1.75),
  },
}));

function BadgePopup({ badgeDetails, badgeData, achieved, progress, open, close, amount, unit }) {
  const classes = useStyles();

  const { icon: Icon, color, title, longDescription } = badgeDetails;

  return (
    <>
      <Dialog open={open} fullWidth maxWidth="sm">
        <DialogContent>
          <div className={classes.contentHead}>
            {Icon && (
              <Icon
                className={classes.icon}
                style={{
                  background: `linear-gradient(to bottom, ${LightenDarkenColor(
                    color,
                    100
                  )}, ${color}`,
                  color: "#FFFFFF",
                }}
              />
            )}
            <div style={{ width: "100%" }}>
              <div className={classes.titles}>
                <Typography variant="h5">{title}</Typography>
                <Typography variant="h6">
                  {amount && unit && `${amount} ${unit}`}
                  {badgeData?.amount && badgeData?.unit && `${badgeData.amount} ${badgeData.unit}`}
                </Typography>
              </div>
              {!achieved && badgeData.amount && (
                <div className={classes.progress}>
                  <Box display="flex" alignItems="center">
                    <Box width="100%" mr={1}>
                      <LinearProgress variant="determinate" value={progress} />
                    </Box>
                    <Box minWidth={35}>
                      <Typography variant="body2" color="textSecondary">{`${Math.round(
                        progress
                      )}%`}</Typography>
                    </Box>
                  </Box>
                  <Typography variant="body2" color="textSecondary">
                    {`${((progress / 100) * badgeData.amount).toLocaleString("de", {
                      useGrouping: false,
                      maximumFractionDigits: 2,
                    })}`}{" "}
                    / {badgeData.amount}
                  </Typography>
                </div>
              )}
              {achieved && (
                <div className={classes.progress}>
                  <Typography variant="caption" color="primary">
                    erhalten am {achieved}
                  </Typography>
                </div>
              )}
            </div>
          </div>
          <Typography variant="body2">{longDescription}</Typography>
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={close}>
            Schließen
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default BadgePopup;
